// middleware/auth.ts
import { defineNuxtRouteMiddleware, navigateTo } from '#app'
import { useLocalePath } from '#imports'
import useAuth from '~/composables/auth/useAuth'

export default defineNuxtRouteMiddleware(async (to) => {
  if (!to.meta.requiresAuth) return

  const localePath = useLocalePath()
  // SSR skip - cookies seems to not be functioning in ssr
  if (process.server) {
    return
  }

  // Prevent redirect loop - if we're already on login page, don't redirect
  if (to.path.includes('/login')) {
    return
  }

  const { checkAuthStatus } = useAuth()

  // Check auth status without auto-redirect
  const isAuthenticated = await checkAuthStatus()

  // if not authenticated
  if (!isAuthenticated) {
    // Remove locale prefix from path to avoid double prefixing when using localePath
    const cleanPath = to.fullPath.replace(/^\/(de-de|en-us)/, '') || '/'
    const redirectTo = encodeURIComponent(cleanPath)

    return navigateTo(localePath(`/login?redirectTo=${redirectTo}`), {
      external: true,
    })
  }
})
